import React, { Component } from 'react'
import Search from '../../components/faq-common/search';
import Main from '../../components/faq-common/main';

export default class Faq extends Component {
    state = {
        searchName: ''
    }

    setSearchName = (searchName) => {
       // this.searchName = searchName
        this.setState({searchName})
    }

    render() {
        return (
            <div>
                <Search setSearchName = {this.setSearchName} />
                <Main searchName = {this.state.searchName} />
            </div>
            )
        }
    }